<template>
    <div id="invoiceProducts">
        <b-alert v-model="showErrorMessage" variant="danger" :dismissible="false">
            <span>{{errorMessage}}</span>
        </b-alert>    
        <div>
            <invoiceItemsGrid 
                :isSelectOptions="isSelectOptions" 
                :columns="columns" 
                :rows="getItems" 
                :isResetBtn="true" 
                :labelAdd="$t('Ajouter un produit')"
                :searchTerm="searchText"
                @on-selection="onSelection" 
                @on-multiple-selection="onMultipleSelection" 
            />
        </div>
    </div>
</template>

<script>

import mapGetter from '@/mixins/getters.js'
import itemColumnHeaders from '@/mixins/itemColumnHeaders.js';
import invoiceItemsGrid from '@/components/invoice/invoiceItemsGrid/invoiceItemsGrid'
import {dataService} from '@/services'
import store from '@/store'
export default{
    name: "invoiceProducts",
    mixins:[itemColumnHeaders, mapGetter],
    components: {
        invoiceItemsGrid,
    },
    props: {
        searchText: {
            type: [String],
            required: false,
            default: ''
        }, 
    },
        data() {
            return{
                id:'',
                fromApi: null,
                rows: [],
                isSelectOptions : false,
                isloadingIcon: false,
                errorMessage : '',
                showErrorMessage: false,
                columns : [],
                selectedRows: []
            }
        },
        methods: {
            loadColumns()
            {
                try {
                    this.columns = this.$CObj(this.getItemColumnHeaders());
                } catch(e) {
                    this.errorMessage = e
                    this.showErrorMessage = true
                }
            },
            loadApi() {
                //Mettre à jours les profuits
                dataService.getProducts()
            },

            onSelection(params){
                this.$emit('add-products', {rows: params.selectedRows, isMultiple: false});                
            },
            onMultipleSelection(params) {
                this.$emit('add-products', {rows: params.selectedRows, isMultiple: true});
            }

        },
        //------------------------------------------------------------------------------------------------
        computed: {
            /**
             * Retourne la liste des items sauvegardé dans le local
             */
             getItems : () => {
                let items = store.getters.getItems?.data
                return items.map(item => item.itemHdr);
             }

            
        },
        mounted() {
            this.loadColumns()
            this.loadApi() 
        },
        created () {
            
        },
        beforeUnmount() {
            
        },
        watch: {
           
        },   
}
</script>

<style lang="scss" scoped>

</style>

